var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.result)?_c('b-card-body',[_c('table',{staticClass:"table table-md mb-3"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Produkter")]),_c('th',[_vm._v("Antal")])])]),_c('tbody',_vm._l((_vm.result),function(item){return _c('tr',{key:item.product},[_c('td',[_vm._v(_vm._s(item.product))]),_c('td',[_vm._v(_vm._s(item.count))])])}),0)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }